<div class="bet-summary-panel" data-cy="bet-summary-panel">

  <!-- Header section -->
  <header class="bet-summary-panel_header">
    <div class="bet-summary-panel_title">
      <mat-icon class="bet-summary-panel_title-icon">receipt_long</mat-icon>
      <span>{{ 'betsummary' | translate: 'Bet Summary' }}</span>
    </div>
    <button
      type="button"
      class="bet-summary-panel_close"
      (click)="close()"
      attr.aria-label="{{ 'ui.wager.close.bet.summary' | translate: 'Close bet summary' }}"
      data-cy="bet-summary-close"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <!-- Totals list section -->
  <ul class="bet-summary-panel_list">

    <!-- Stacked Bets -->
    <li class="bet-summary-panel_row" data-cy="stacked-bets-text">
      <span class="bet-summary-panel_label">{{ 'ui.wager.stacked.bets' | translate: 'Stacked Bets' }}</span>
      <span class="bet-summary-panel_value">
        <span class="bet-summary-panel_currency">$</span>
        <span class="stack-today-sum" data-cy="stack-today-sum">
          {{ totals.stackTodaySum | numberWithCommas }}
        </span>
      </span>
    </li>

    <!-- Bet Today -->
    <li class="bet-summary-panel_row" data-cy="bet-today-text">
      <span class="bet-summary-panel_label">{{ 'betsummary.bettoday' | translate: 'Bet Today' }}</span>
      <span class="bet-summary-panel_value">
        <span class="bet-summary-panel_currency">$</span>
        <span class="bet-today-sum" data-cy="bet-today-sum">
          {{ totals.betTodaySum | numberWithCommas }}
        </span>
      </span>
    </li>

    <!-- Won Today -->
    <li class="bet-summary-panel_row" data-cy="won-today-text">
      <span class="bet-summary-panel_label">{{ 'betsummary.wontoday' | translate: 'Won Today' }}</span>
      <span class="bet-summary-panel_value bet-summary-panel_value--positive">
        <span class="bet-summary-panel_currency">$</span>
        <span class="won-today-sum" data-cy="won-today-sum">
          {{ totals.wonTodaySum | numberWithCommas }}
        </span>
      </span>
    </li>

    <!-- Profit / Loss -->
    <li class="bet-summary-panel_row" data-cy="profit-loss-text">
      <span class="bet-summary-panel_label">{{ 'betsummary.profitloss' | translate: 'Profit / Loss' }}</span>
      <span
        class="bet-summary-panel_value"
        [class.bet-summary-panel_value--negative]="isNegative(totals.profitLossSum)"
        [class.bet-summary-panel_value--positive]="isPositive(totals.profitLossSum)"
      >
        <span class="bet-summary-panel_currency">$</span>
        <span class="profit-loss-sum" data-cy="profit-loss-sum">
          {{ totals.profitLossSum | numberWithCommas }}
        </span>
      </span>
    </li>

    <!-- Active Bets -->
    <li class="bet-summary-panel_row" data-cy="active-bets-text">
      <span class="bet-summary-panel_label">{{ 'betsummary.activebets' | translate: 'Active Bets' }}</span>
      <span class="bet-summary-panel_value">
        <span class="bet-summary-panel_currency">$</span>
        <span class="active-bets-sum" data-cy="active-bets-sum">
          {{ totals.activeBetsSum | numberWithCommas }}
        </span>
      </span>
    </li>

    <!-- Real Time P/L -->
    <li class="bet-summary-panel_row" data-cy="real-time-pl-text">
      <span class="bet-summary-panel_label">{{ 'betsummary.realtimepl' | translate: 'Real Time P/L' }}</span>
      <span
        class="bet-summary-panel_value"
        [class.bet-summary-panel_value--negative]="isNegative(totals.realTimePlSum)"
        [class.bet-summary-panel_value--positive]="isPositive(totals.realTimePlSum)"
      >
        <span class="bet-summary-panel_currency">$</span>
        <span class="real-time-pl-sum" data-cy="real-time-pl-sum">
          {{ totals.realTimePlSum | numberWithCommas }}
        </span>
      </span>
    </li>
  </ul>
</div>
